import { useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

export const NotesBlock = ({ notes, leadId, reload }) => {
  const [content, setContent] = useState("");
  const [saving, setSaving] = useState(false);

  const add = async () => {
    setSaving(true);
    try {
      await api.post(`/leads/${leadId}/notes`, { content });
      setContent("");
      toast.success("Nota agregada");
      reload();
    } catch (e) { toast.error(errorMessage(e)); } finally { setSaving(false); }
  };

  return (
    <div data-testid="notes-block">
      <h3 className="text-sm font-bold">Notas internas</h3>
      <Textarea rows={2} value={content} onChange={(e) => setContent(e.target.value)} placeholder="Escribe una nota…" className="mt-3 rounded-xl" data-testid="note-input" />
      <Button onClick={add} disabled={!content.trim() || saving} className="mt-2 h-9 w-full rounded-xl bg-[#0B2545]" data-testid="add-note-button">Guardar nota</Button>
      <ul className="mt-4 space-y-2" data-testid="notes-list">
        {notes.length === 0 && <li className="text-sm text-slate-400">Sin notas</li>}
        {notes.map((n) => (
          <li key={n.id} className="rounded-xl border-l-2 border-[#14B8A6] bg-[#F5F7FA] p-3" data-testid={`note-item-${n.id}`}>
            <p className="whitespace-pre-wrap text-sm">{n.content}</p>
            <p className="mt-1.5 text-xs text-slate-400">{n.author_name} · {fmtDateTime(n.created_at)}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};
